import { ButtonBS, ButtonProps, Icon } from "@biblioteksentralen/react";
import { MouseEventHandler } from "react";
import { Search } from "react-feather";
import { useFeatureToggle } from "../../../utils/hooks/featureToggles";
import { useTranslation } from "../../../utils/hooks/useTranslation";
import InternalLink from "../../InternalLink";
import { headerLinkDecorationStyle } from "../utils";

type HeaderSearchButtonProps = { onClick: MouseEventHandler; searchIsOpen: boolean } & ButtonProps;

export const HeaderSearchButton = ({ onClick, searchIsOpen, ...buttonProps }: HeaderSearchButtonProps) => {
  const { t } = useTranslation();
  const nullsokToggle = useFeatureToggle("nullsok");

  return (
    <ButtonBS
      onClick={nullsokToggle ? undefined : onClick}
      aria-expanded={nullsokToggle ? undefined : searchIsOpen}
      as={nullsokToggle ? InternalLink : undefined}
      href={nullsokToggle ? "/sok" : undefined}
      variant="plain"
      css={headerLinkDecorationStyle(searchIsOpen)}
      fontSize="md"
      {...buttonProps}
    >
      <Icon width="1em" height="1em" asChild strokeWidth={2.2}>
        <Search />
      </Icon>
      {t("Søk")}
    </ButtonBS>
  );
};
